<template>
    <main class="main">
        <div class="main__page">
            <div class="card__header">
                <h2 class="main-title">
                    {{ $t('checksheet.titleTable') }}
                </h2>
            </div>
            <div class="card">
                <div class="card__detail">
                    <div class=" loading">
                        <div class="list__item" v-for="cs in this.checksheets.data">
                            <span class="col">
                                <strong>{{ cs.customer.agency }}</strong>
                                {{ cs.customer.address }}
                            </span>
                            <span class="col">
                                {{ cs.data_controllo | formatDate }}
                            </span>

                            <span class="col">
                                <button class="btn light" type="button" @click="preview(cs)" :disabled="loading">
                                    <span>{{ $t('common.preview') }}</span>
                                </button>
                              	<button class="btn" type="button" @click="downloadPdf(cs)" :disabled="loading">
                                  <span v-if="loading">{{ $t('common.loading') }}</span>
                                  <span v-if="!loading">{{ $t('common.download') }}</span>
                                </button>
                            </span>
                        </div>
                    </div>
                    <Pagination v-model="checksheets"></Pagination>
                </div>
            </div>
        </div>
        <anteprima-modal v-model="showPreview" :item="dataPreview" :structure="checksheets.structureDoc"></anteprima-modal>
    </main>
</template>
<script>
    import Pagination from "../../components/Pagination";
    import AnteprimaModal from "../../components/AnteprimaModal";

    export default {
        name: 'checksheets',
        components: {
            AnteprimaModal,
            Pagination},
        mounted() {
            this.init();
        },
        data() {
            return {
                'checksheets': this.api.checksheets,
                'isFiltered': false,
                'searchText': null,
                'p': this.pdf,
                'loading': false,
                'showPreview': false,
                'dataPreview': null
            }
        },
        methods: {
            init() {
                this.checksheets = this.api.checksheets;
                this.checksheets.getList();
            },
            submitSearch() {
                this.searchText = this.searchText.trim();
                this.isFiltered = false;
                this.checksheets.getList(this.searchText);
                if(this.searchText != "") {
                    this.isFiltered = true;
                }
            },
            clearSearch() {
                this.searchText = "";
                this.checksheets.getList(this.searchText);
                this.isFiltered = false;
            },
            downloadPdf(item) {
                this.loading = true;
                this.p.buildPdf(this.api.checksheets.structureDoc, item, (status) => {
                    if(status == 'end') {
                        this.loading = false;
                    }
                });
            },
            preview(item) {
                this.dataPreview = item;
                this.showPreview = !this.showPreview;
            }
        }
    }
</script>
<style lang="scss">
    @import './src/scss/variables';
    .card {
        &__header {
            display: flex;
            justify-content: space-between;
            background: transparent;
            height: auto;
            padding: 30px 0;
            .card__header-link {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                background: $middle-green;
                padding: 10px 20px;
                transition: 300ms $ease-out-quint;
                .btn {
                    &-icon .bar,
                    &-label {
                        transition: 300ms $ease-out-quint;
                    }
                    &-icon {
                        display: block;
                        width: 20px;
                        height: 20px;
                        margin-right: 15px;
                        position: relative;
                        .bar {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            background: $white;
                            width: 15px;
                            height: 4px;
                            transform: translate(-50%,-50%);
                            &:last-of-type {
                                transform: translate(-50%,-50%) rotate(90deg);
                            }
                        }
                    }
                    &-label {
                        display: block;
                        font-weight: 700;
                        font-size: 0.8em;
                        color: $white;
                        text-transform: uppercase;
                    }
                }
                &:hover {
                    background: $white;
                    .btn {
                        &-icon .bar { background: $middle-green; }
                        &-label { color: $middle-green; }
                    }
                }
            }
        }
    }
    .customers__list {
        display: flex;
        flex-direction: column;
        .customer {
            padding: 15px 10px;
            position: relative;
            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                background: $middle-green;
                width: 100%;
                height: 100%;
                z-index: 1;
                transform: scaleY(0);
                transform-origin: center bottom;
                transition: 600ms $ease-out-quint;
            }
            &__agency,
            &__referent {
                position: relative;
                z-index: 2;
                transition: 600ms $ease-out-quint;
            }
            &__agency {
                display: block;
                width: 100%;
                font-size: 1.5em;
                font-weight: 300;
                padding-bottom: 7px;
            }
            &__referent {
                font-size: 0.7em;
                text-transform: uppercase;
                color: $gray;
                strong {
                    font-weight: 700;
                }
            }
            &:nth-of-type(even) {
                background: rgba($gray, 0.05);
            }
            &:hover {
                .customer__agency,
                .customer__referent {
                    color: $white;
                }
                &:before {
                    transform: scaleY(1);
                    transform-origin: center top;
                }
            }
        }
    }
</style>
